import { useCallback, useEffect, useRef } from "react";
import { Auth0RedirectLoginOptions, useUnifiedAuth } from "../../unified-auth";

export default function Start() {
  const { loginWithAuth0, logout } = useUnifiedAuth();
  const isInitialized = useRef(false);

  const startUnifiedLogin = useCallback(async () => {
    if (isInitialized.current) {
      return;
    }
    isInitialized.current = true;
    const urlParams = new URLSearchParams(window.location.search);
    const prompt = urlParams.get("prompt") ?? undefined;
    
    // Only logout for prompt=login to force re-authentication
    if (prompt === "login") {
      try {
        await logout({ noRedirect: true });
      } catch (error) {
        console.error("Logout failed:", error);
      }
    }

    const email = urlParams.get("email") ?? "";
    const screen_hint = urlParams.get("screen_hint") ?? "login";
    const token = urlParams.get("token") ?? undefined;
    const _gl = urlParams.get("_gl") ?? undefined;
    const _utm_source = urlParams.get("utm_source") ?? undefined;
    const _utm_medium = urlParams.get("utm_medium") ?? undefined;
    const _utm_campaign = urlParams.get("utm_campaign") ?? undefined;
    let ext_gaClientID = urlParams.get("ext-gaClientId") ?? undefined;
    let ext_gaSessionID = urlParams.get("ext-gaSessionId") ?? undefined;
    let ext_anonymousID = urlParams.get("ext-anonymousId") ?? undefined;
    if (ext_gaClientID === "") {
      ext_gaClientID = undefined;
    }
    if (ext_gaSessionID === "") {
      ext_gaSessionID = undefined;
    }
    if (ext_anonymousID === "") {
      ext_anonymousID = undefined;
    }
    const additionalAuthorizationParams: Auth0RedirectLoginOptions["additionalAuthorizationParams"] =
      stripUndefined({
        _gl: _gl,
        utm_source: _utm_source,
        utm_medium: _utm_medium,
        utm_campaign: _utm_campaign,
        "ext-gaClientId": ext_gaClientID,
        "ext-gaSessionId": ext_gaSessionID,
        "ext-anonymousId": ext_anonymousID,
        prompt: prompt,
      });
    let opts: Auth0RedirectLoginOptions = stripUndefined({
      email: email,
      screen_hint: screen_hint,
      token: token,
    });
    if (Object.keys(additionalAuthorizationParams).length > 0) {
      opts = {
        additionalAuthorizationParams: {
          ...additionalAuthorizationParams,
        },
        ...opts,
      };
    }
    if (isInitialized.current) {
      await loginWithAuth0(opts);
    }
  }, [loginWithAuth0, logout]);

  useEffect(() => {
    startUnifiedLogin().then();
  }, [startUnifiedLogin]);

  return null;
}

const stripUndefined = (params: any) => {
  return Object.keys(params)
    .filter((k) => typeof params[k] !== "undefined")
    .reduce((acc, key) => ({ ...acc, [key]: params[key] }), {});
};
